import { useEffect, useState } from 'react';
import { type FamilyStory } from '../lib/api';
import { CameraIcon, VideoIcon } from './Icons';

/**
 * A story poster that degrades to the first frame of a video while Nextcloud
 * is still preparing (or cannot prepare) its server-side preview.
 */
export function StoryThumbnail({ story, size, alt = '' }: {
  story: FamilyStory;
  size: number;
  alt?: string;
}) {
  const [fallback, setFallback] = useState<'none' | 'video' | 'icon'>('none');

  useEffect(() => setFallback('none'), [story.id, story.previewUrl]);

  if (fallback === 'video' && story.isVideo) {
    return (
      <video
        src={`${story.mediaUrl}#t=0.1`}
        autoPlay
        muted
        playsInline
        loop
        preload="metadata"
        aria-hidden="true"
        onError={() => setFallback('icon')}
      />
    );
  }

  if (fallback === 'icon') {
    return (
      <span className="story-thumbnail-fallback" aria-hidden="true">
        {story.isVideo ? <VideoIcon /> : <CameraIcon />}
      </span>
    );
  }

  return (
    <img
      src={`${story.previewUrl}?size=${size}`}
      alt={alt}
      loading="lazy"
      onError={() => setFallback(story.isVideo ? 'video' : 'icon')}
    />
  );
}
